import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-custom-snack',
  templateUrl: './custom-snack.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

/** Тестовый кастомный компонент для  снэкбара */
export class CustomSnackComponent {
  click(): void {
    alert('alert');
  }
}
